export const instantAccessItems: string[] = [
  'Les 10 tomes de la collection',
  '600 pages dans les tomes principaux',
  'Des fiches et activités en français',
  'Des supports visuels pour accompagner les consignes',
  'Des projets et travaux pratiques',
  'Des corrigés et critères d’observation',
  'Les 5 bonus complémentaires',
]

export const usageSteps: { title: string; description: string }[] = [
  {
    title: 'Choisissez votre objectif',
    description: 'Repérez une activité d’écoute, de rythme, de voix ou de création.',
  },
  {
    title: 'Préparez vos supports',
    description: 'Sélectionnez les fiches et cartes à imprimer ou à projeter.',
  },
  {
    title: 'Faites pratiquer et observez',
    description: 'Guidez la séance, adaptez les consignes et utilisez les corrigés ou critères proposés.',
  },
]
